import { useConfigTypeTitle } from '@eggplant/routing'

const StopOnFailureFieldsetDescription = () => {
  const configTypeTitle = useConfigTypeTitle(true)

  return (
    <>
      {configTypeTitle} config continues to run even if a step fails, and it continues running until all steps, including reruns, are completed.
    </>
  )
}

export default StopOnFailureFieldsetDescription
